module.exports = __webpack_public_path__ + "media/images/flags/mo-fc8abeebf8b90cc76634f45369ad5bc4.svg";